import type { CSSProperties, ReactNode } from "react";
import { useRef } from "react";
import { CSSTransition } from "react-transition-group";

import styles from "./style.module.scss";

interface IBulkActionsMenu {
    /**
     * Selected rows count
     */
    selectedRowsCount: number;
    /**
     * Show bulk actions menu
     */
    show: boolean;
    /**
     * Children content of the bulk action menu
     */
    children: ReactNode;
    /**
     * CSS Style
     */
    style?: CSSProperties;
}

/**
 * Reusable component, show bulk actions menu when selecting multiple table rows
 */
const BulkActionsMenu = ({ selectedRowsCount, show, children, style }: IBulkActionsMenu) => {
    const actionsRef = useRef(null);

    return (
        <CSSTransition
            nodeRef={actionsRef}
            in={show}
            timeout={200}
            classNames={{
                enter: styles["bulk-actions-transition-enter"],
                enterActive: styles["bulk-actions-transition-enter-active"],
                exit: styles["bulk-actions-transition-exit"],
                exitActive: styles["bulk-actions-transition-exit-active"],
            }}
            unmountOnExit
        >
            <div className={styles["bulk-actions-menu"]} style={style} ref={actionsRef}>
                <div className={styles["selected-rows-count"]}>{selectedRowsCount}</div>
                {children}
            </div>
        </CSSTransition>
    );
};

export default BulkActionsMenu;
